import { atom } from 'recoil';

export const userInfoState = atom({
  key: 'memberInfoState',
  default: {
    userId: '',
    userName: '',
    maskingUserName: '',
    siteNumber: '',
    subsidiaryCompanyCode: '',
    loginType: '',
    memberNumber: '',
    adultCertificationDate: '',
    employNumber: '',
    mileageFlag: true,
    otpUseYn: false,
  },
});

export const recentlyViewedGoodListState = atom({
  key: 'recentlyViewedGoodListState',
  default: null,
});
